module.exports = __webpack_public_path__ + "img/1749030690_KnmI_ar.0a894784.png";